
const Sustentabilidad = () => {
  return (
    <div className="sb">
        <div className="sb__content">
            <div className="box">
                <div className="text">
                    <h2>EL COMPROMISO DE LA TORTUGA</h2>
                    <p>En nuestro camino por ser 80% sustentable al 2025, apostamos por seguir desarrollando productos cada vez más amigables con nuestra flora, fauna y funga.</p>
                </div>
                <div className="sb-icon">
                    <img src="https://res.cloudinary.com/lippi-outdoor/image/upload/v1666120409/home-hakahonu/new-home/LOGO_SUSTENTABLE_ocbrqv.png" alt="" />
                </div>
            </div>
        </div>
    </div>
  )
}

export default Sustentabilidad